import React from "react";
import { Link } from "react-router-dom";

import {
  biondRoute,
  blogRoute,
  businessRoute,
  contactRoute,
  faqRoute,
  pricingRoute,
  privacyPolicyRoute,
  termsOfServiceRoute
} from "constants/routes";

export const FooterNavigation = () => (
  <nav className="footer__nav__lists">
    <ul className="footer__nav__list">
      <li className="footer__nav__item">
        <Link to={biondRoute} className="footer__nav__link">
          Biond
        </Link>
      </li>
      <li className="footer__nav__item">
        <Link to={businessRoute} className="footer__nav__link">
          Business
        </Link>
      </li>
      <li className="footer__nav__item">
        <Link to={pricingRoute} className="footer__nav__link">
          Pricing
        </Link>
      </li>
      <li className="footer__nav__item">
        <Link to={faqRoute} className="footer__nav__link">
          FAQ
        </Link>
      </li>
      <li className="footer__nav__item">
        <Link to={blogRoute} className="footer__nav__link">
          Blog
        </Link>
      </li>
    </ul>
    <ul className="footer__nav__list">
      <li className="footer__nav__item">
        <Link to={privacyPolicyRoute} className="footer__nav__link">
          Privacy policy
        </Link>
      </li>
      <li className="footer__nav__item">
        <Link to={termsOfServiceRoute} className="footer__nav__link">
          Terms of Service
        </Link>
      </li>
      <li className="footer__nav__item">
        <Link to={contactRoute} className="footer__nav__link">
          Contact
        </Link>
      </li>
    </ul>
  </nav>
);



// WEBPACK FOOTER //
// ./src/components/Footer/FooterNavigation.jsx